// Nouveau composant TranslationBadge.jsx (dans Discussion/components/)
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

const TranslationBadge = ({ sourceLang, translatedText }) => {
  const { t } = useTranslation();
  const [showTranslation, setShowTranslation] = useState(false);

  const langName = t(`languages.${sourceLang}`, { defaultValue: sourceLang });

  return (
    <div style={{ marginTop: '4px' }}>
      {/* Affichage de la traduction si demandée */}
      {showTranslation && (
        <div style={{
          marginTop: '4px', padding: '6px 8px',
          borderLeft: '2px solid var(--color-border-secondary)',
          fontSize: '0.9em', color: 'var(--color-text-secondary)',
          fontStyle: 'italic'
        }}>
          {translatedText}
        </div>
      )}

      <button
        onClick={(e) => { e.stopPropagation(); setShowTranslation(v => !v); }}
        style={{
          background: 'none', border: 'none', padding: '0',
          fontSize: '0.75em', color: 'var(--color-text-secondary)',
          cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '4px'
        }}
      >
        🌐 {showTranslation
          ? t('discussion.hideTranslation')
          : t('discussion.showTranslation', { lang: langName })
        }
      </button>
    </div>
  );
};

export default TranslationBadge;